import { Helmet } from "react-helmet-async";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    question: "How long does it take to get my gamification strategy?",
    answer: "Just 10 minutes to complete the assessment, and you'll receive your personalized AI-generated strategy within 2 minutes via email. Total time investment: under 15 minutes.",
  },
  {
    question: "What if I'm not satisfied with my gamification strategy?",
    answer: "We offer a 30-day money-back guarantee, no questions asked. If you're not satisfied with your strategy, we'll refund your $79 payment in full.",
  },
  {
    question: "Can I use this gamification tool for multiple apps?",
    answer: "This assessment is designed for one app at a time to ensure personalized, focused recommendations. If you need strategies for multiple apps, please contact us for multi-app pricing options.",
  },
  {
    question: "What types of apps does the gamification strategy work for?",
    answer: "Our AI-powered assessment works for all app types across 6 major categories: Education & Learning, Entertainment & Gaming, Health & Wellness, Personal Development, Productivity & Organization, and Social & Community apps.",
  },
  {
    question: "What's included in the gamification strategy package?",
    answer: "You receive a customized gamification strategy with engagement tier recommendations, specific game mechanics for your app, technical specifications (JSON file), design guidelines (PDF), and a complete implementation roadmap.",
  },
  {
    question: "How does the AI-powered gamification assessment work?",
    answer: "Our assessment asks 7 targeted questions about your app type, target users, usage patterns, challenges, and goals. The AI analyzes your responses to generate a personalized gamification strategy tailored to your specific needs.",
  },
  {
    question: "Is this better than hiring a gamification consultant?",
    answer: "For most app developers, yes. Traditional consultants charge $5,000-$15,000 and take weeks to deliver. Our AI-powered tool costs just $79, delivers in minutes, and provides equally personalized recommendations based on proven gamification frameworks.",
  },
  {
    question: "Do I need technical knowledge to implement the strategy?",
    answer: "No! The strategy package includes clear implementation guidelines suitable for both technical and non-technical founders. The JSON specs can be handed directly to your development team, while the PDF provides visual guidance for designers.",
  },
];

const FAQ = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map((faq) => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer,
      },
    })),
  };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(faqSchema)}
        </script>
      </Helmet>
      <section aria-labelledby="faq-heading" itemScope itemType="https://schema.org/FAQPage">
        <h2 id="faq-heading" className="text-3xl font-bold text-center mb-8">
          Frequently Asked Questions About Gamification
        </h2>
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, index) => (
            <AccordionItem 
              key={index} 
              value={`item-${index}`}
              itemScope
              itemProp="mainEntity"
              itemType="https://schema.org/Question"
            >
              <AccordionTrigger className="text-left font-semibold">
                <span itemProp="name">{faq.question}</span>
              </AccordionTrigger>
              <AccordionContent 
                className="text-muted-foreground"
                itemScope
                itemProp="acceptedAnswer"
                itemType="https://schema.org/Answer"
              >
                <span itemProp="text">{faq.answer}</span>
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </section>
    </>
  );
};

export default FAQ;
